/*
 * @Description: 服务详情
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import TabsBox from './components/tabsBox.vue'
import StoreInfo from './components/storeInfo.vue'
import BaseInfo from './components/baseInfo.vue'
import LotteryResume from './components/lotteryResume.vue'
import CouponInfo from '../../components/couponInfo/couponInfo.vue'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import { wxShare } from '@/utils/wxsdk'
// import { toQueryObject } from '@/utils/util'
import { ActionSheet, Toast } from 'vant'

import {
    setLocalConfig
} from '@/utils/session'
import {
    getCoupon
} from '@/models/coupon'
import {
    getServiceDetail,
    sendTipsStore,
    getServiceCouponList
} from '@/models/service.js'
import { isString } from 'lodash'
export default {
    name: viewName.serviceDetail,
    inject: ['showLoading', 'hideLoading'],
    components: {
        TabsBox,
        BaseInfo,
        StoreInfo,
        LotteryResume,
        ActionSheet,
        Toast,
        CouponInfo,
        appGuideDialog
    },
    data () {
        return {
            req_success: false, // 是否已请求数据完成
            res: {}, // 接口数据
            sstore_id: '', // 门店id
            baseItemCode: '', // 父节点的编码
            service_id: '', // 服务子节点的id
            is_selectd: '', // 当前服务是否已选
            isTipsSend: false, // 是否已经发送提示过门店
            source: '', // 来源
            isShowSelectBtn: false, // 判断是否显示选择按钮
            sms_id: '', // (短信营销码)判断是否显示立即购买按钮
            show: false,
            couponList: {
                can_coupon_list: [],
                has_coupon_list: [],
            },
            noOnlyBuy: false,
            jumpSmallWeChatParams: {
                user_receive_coupon_id: '',
                coupon_id: '',
                sstore_id: '',
                coupon_type: '',
                is_details: ''
            },
            jumpType: 'couponGoodsList' // 跳转小程序页面
        }
    },
    computed: {
        ...mapState({
            adviceList: ({ advice }) => advice.list, // 保养项目列表
            selectServicesList: ({ advice }) => advice.selectData.servicesList, // 已选服务数据列表
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
    },
    watch: {
        $route: {
            handler: function (newRoute) {
                const { has_history, sms_id, noOnlyBuy = true } = newRoute.query
                this.isShowSelectBtn = has_history == null
                this.sms_id = sms_id
                this.noOnlyBuy = isString(noOnlyBuy) ? JSON.parse(noOnlyBuy) : noOnlyBuy
            },
            immediate: true // 进页面默认触发一次
        }
    },
    created () {
        this.$setgoindex()
        // 调取，用于通过code获取用户信息并且保存到本地并且进行绑定手机号码的逻辑
        // this.getWxUserInfo(this.$route.query.code || '').then(_ => {
        //     const _thisPath = this.$route.path
        //     let _thisQuery = this.$route.query
        //     _thisQuery['code'] && delete _thisQuery['code'] && this.$router.replace(`${_thisPath}?${toQueryObject(_thisQuery)}`)
        // })
        this.$emit('setHeader', {
            title: '服务详情',
            showHeader: true,
            showLeft: !this.sms_id
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgWhiteColor'
        })
        /* 获取地址参数 */
        const { sstore_id, baseItemCode, service_id, source, is_selectd } = this.$route.query
        this.sstore_id = sstore_id
        this.baseItemCode = baseItemCode
        this.service_id = service_id
        this.source = source
        this.is_selectd = is_selectd
    },
    activated () {

    },
    mounted () {
        /* 请求数据 */
        this.getData()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'updateAdviceList',
            'getWxUserInfo',
            'verifyUserInfo',
        ]),
        /**
         * 配置微信分享
         */
        configWxShare () {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: this.res.service_name,
                    imgUrl: this.res.service_icon,
                    desc: '【枫车养车】优质服务放心选！'
                })
            }
        },
        /**
     * 发送门店提示
     */
        async onSendTipsStore () {
            if (this.isTipsSend) {
                this.$toast('已提醒，无需重复提醒')
            } else {
                this.$toast('提醒成功')
                await sendTipsStore({
                    sstore_id: this.sstore_id,
                    service_id: this.service_id
                })
            }
            this.isTipsSend = true
        },
        /**
     * 请求数据
     */
        async getData () {
            this.showLoading()
            const res = await getServiceDetail({
                sstore_id: this.sstore_id,
                service_id: this.service_id,
                sms_id: this.sms_id
            })
            this.hideLoading()
            this.res = res
            this.req_success = true
            /* 微信分享 */
            this.configWxShare()
            /* 调用倒计时 */
            this.$nextTick(() => {
                if (this.res.count_down > 0) {
                    this.$refs.lotteryResume.startCountDown()
                }
            })
        },
        /* 改变该服务的选中状态 */
        onChangeSelect () {
            if (this.source === 'advice') {
                const list = JSON.parse(JSON.stringify(this.adviceList))
                for (let i = 0; i < list.length; i++) {
                    const item = list[i]
                    if (item.baseItemCode === this.baseItemCode) {
                        let project = item['services']
                        for (let j = 0; j < project.length; j++) {
                            let childrenItem = project[j]
                            /* 唯一标识 */
                            if (childrenItem.service_id === this.service_id) {
                                /* 核心 */
                                list[i]['services'][j].is_selectd = Number(!this.is_selectd)
                            }
                        }
                    }
                }
                this.updateAdviceList(list)
            } else {
                const { is_selectd } = this.$route.query
                sessionStorage.setItem('now_service', JSON.stringify({
                    service_id: this.service_id,
                    is_selectd: Number(!is_selectd)
                }))
            }
            /* 返回上一页 */
            this.$router.go(-1)
        },
        buy () {
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                let param = {
                    service_id: this.res.service_id,
                    price: this.res.service_price,
                    quantity: 1,
                }
                let arr = []
                arr.push(param)
                /* 设置sessionStorage数据 给确认订单使用 */
                setLocalConfig('CONFIRM_ORDER', {
                    sstore_id: this.sstore_id,
                    services: arr,
                    sms_id: this.sms_id
                })
                /* 跳转确认订单 */
                this.$router.push({
                    path: '/confirmOrder',
                    query: {}
                })
            })
        },
        showTips (coupon) {
            Object.assign(this.jumpSmallWeChatParams, {
                user_receive_coupon_id: coupon.user_coupon_id,
                coupon_id: coupon.coupon_id,
                sstore_id: this.sstore_id,
                wechat_sstore_id: coupon.wechat_sstore_id,
                coupon_type: coupon.type === 'bc' ? '1' : '2',
                is_details: '1'
            })
            this.$refs.appGuideDialog.open()
        },
        // 领取优惠券
        clickGetCoupon (coupon) {
            let couponInfo = coupon
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                this.showLoading()
                getCoupon({
                    coupon_id: couponInfo.coupon_id,
                    type: couponInfo.type
                }).then(res => {
                    this.hideLoading()
                    this.$toast('领取成功')
                    this.getServiceCouponList()
                }).catch(err => {
                    this.hideLoading()
                    console.log(err)
                })
            })
        },
        /**
     * 请求数据
     */
        getServiceCouponList () {
            this.showLoading()
            getServiceCouponList({
                services_id: this.service_id,
                sstore_id: this.sstore_id
            }).then(res => {
                this.hideLoading()
                const can_coupon_lis = res.can_coupon_list.map((item) => {
                    item.is_get = 0
                    return item
                })
                const has_coupon_list = res.has_coupon_list.map((item) => {
                    item.is_get = 1
                    return item
                })

                res.can_coupon_list = can_coupon_lis
                res.has_coupon_list = has_coupon_list
                this.couponList = res
            }).catch(err => {
                this.hideLoading()
                console.log(err)
            })
        },
        openCouponList () {
            this.getServiceCouponList()
        }
    },
}
